import { RoutablePage, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { STATIC_PAGES_NAMESPACE } from '../../store/modules/static-pages/static-pages.store.js';
import { store } from '../../store/index.js';

var staticPagesModule = namespace(STATIC_PAGES_NAMESPACE);
var StaticPageComponent = /** @class */ (function (_super) {
    __extends(StaticPageComponent, _super);
    function StaticPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pages = [];
        _this.selectedTab = '';
        _this.defaultTab = '';
        _this.contentHeaderSlug = 'rgp-rgp_header';
        _this.defaultRgPageSlug = 'rgp_responsible-gaming';
        return _this;
    }
    StaticPageComponent.prototype.onCurrentTabChange = function () {
        this.handleTabChange(this.currentTab);
    };
    StaticPageComponent.prototype.onError = function () {
        this.routeTo({ route: RoutablePage.NOT_FOUND });
    };
    StaticPageComponent.prototype.handleTabChange = function (slug) {
        this.selectedTab = slug;
        this.emitTabChange();
    };
    StaticPageComponent.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var lang, category;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lang = this.magicConfig.language;
                        category = this.category;
                        return [4 /*yield*/, this.fetchStaticPagesData(category, lang)];
                    case 1:
                        _b.sent();
                        this.pages = this.getCategory;
                        this.selectedTab = this.currentTab;
                        this.defaultTab = (_a = this.filteredPages[0]) === null || _a === void 0 ? void 0 : _a.slug;
                        this.emitTabChange();
                        return [2 /*return*/];
                }
            });
        });
    };
    StaticPageComponent.prototype.fetchStaticPagesData = function (category, lang) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.fetchCategory({ category: category, lang: lang })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StaticPageComponent.prototype.emitTabChange = function () {
        this.$emit('tab-change', this.selectedTab || this.defaultTab);
    };
    Object.defineProperty(StaticPageComponent.prototype, "filteredPages", {
        get: function () {
            var _this = this;
            return this.pages.filter(function (page) {
                return page.slug !== _this.defaultRgPageSlug &&
                    page.slug !== _this.contentHeaderSlug;
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        staticPagesModule.Getter('getCategory'),
        __metadata("design:type", void 0)
    ], StaticPageComponent.prototype, "getCategory", void 0);
    __decorate([
        staticPagesModule.Action('fetchCategory'),
        __metadata("design:type", Object)
    ], StaticPageComponent.prototype, "fetchCategory", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageComponent.prototype, "category", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageComponent.prototype, "currentTab", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageComponent.prototype, "enhancedCoversOnStaticPages", void 0);
    __decorate([
        Watch('currentTab'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StaticPageComponent.prototype, "onCurrentTabChange", null);
    StaticPageComponent = __decorate([
        Component({
            name: 'static-pages',
            store: store,
        })
    ], StaticPageComponent);
    return StaticPageComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default StaticPageComponent;
